import { createContext } from "react";

interface Context {
    financialTransactionsToRemoveIds: number[];
    statementTransactionsToAddIds: string[];
    registerFinancialTransactionToRemove(id: number): void;
    unregisterFinancialTransactionToRemove(id: number): void;
    registerStatementTransactionToAdd(id: string): void;
    unregisterStatementTransactionToAdd(id: string): void;
}

export const ReconciliationContext = createContext<Context>({
    financialTransactionsToRemoveIds: [],
    statementTransactionsToAddIds: [],
    registerFinancialTransactionToRemove: () => {},
    unregisterFinancialTransactionToRemove: () => {},
    registerStatementTransactionToAdd: () => {},
    unregisterStatementTransactionToAdd: () => {},
});
